<mat-form-field>
  <div class="search-container nli-search">
    <label>{{label}}</label>
    <input matInput [id]="id+'-srachInput'" class="search-box" [(ngModel)]="value" type="text" name="search" (keyup.enter)="enterTyped()">
    <mat-icon class="search-icon" *ngIf="isEmpty()">search</mat-icon>
    <mat-icon class="search-icon" style="cursor: pointer;" *ngIf="!isEmpty()" (click)="clearClicked()">clear</mat-icon>
  </div>
</mat-form-field>